export default (theme) => ({
    toField: {
        display: 'flex',
        height: '100%',
        paddingRight: 20,
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    statusField: {
        display: 'flex',
        height: '100%',
        alignItems: 'center',
    },
    toFieldName: {
        fontWeight: 500,
        color: `${theme.colors.primary.black} !important`,
    },
    field: {
        display: 'flex',
        height: '100%',
        paddingRight: 20,
        alignItems: 'center',
    },
    editLink: {
        marginLeft: 10,
    },
    switchFormatter: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '0 20px',
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
    },
});
